// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './assets/css/zy-icon.css'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import api from './api/'
import configSystem from './config/config_system'
import dataSystem from './store/data_system'
import './assets/css/base.css'
import './assets/css/lcd-font.css'
import BaiduMap from 'vue-baidu-map-v3'
import router from './router'
import store from './store'
import App from './App'

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.config.silent = true; // 关闭console中的Vue Warn
Vue.prototype.$api = api;
Vue.prototype.GlobalConfig = configSystem;
Vue.prototype.GlobalData = dataSystem;
Vue.use(BaiduMap, {
  ak: 'GNWX7KV8SwYVExGrRaZyclmMa4Ev5Mek'
})

Vue.prototype.isArrayFn = function (o) {
  return Object.prototype.toString.call(o) === '[object Array]';
};

/** *start 全局变量*****/
Vue.prototype.input_size = 8;
Vue.prototype.page_size = 18;
/** *end 全局变量*****/

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js